import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCartTotals from 'store/cart/selector/getCartTotals';
import styles from './OrderTotal.module.scss';

const OrderTotal: React.FC = () => {
  const cartTotals = useSelector(getCartTotals);
  const { t } = useTranslation();
  const discountAvaiable = cartTotals ? cartTotals?.total?.value !== cartTotals?.totalDiscount?.value : false;

  return (
    <div>
      <div className={styles.total}>
        <div className={styles.totalTextCell}>
          <OpText variant="body" size="large">
            {t('txt_total')}:
          </OpText>
        </div>
        {discountAvaiable && (
          <OpText variant="title" size="medium">
            <div
              className={styles.priceWithoutDiscount}
              dangerouslySetInnerHTML={{ __html: String(cartTotals?.totalInitial?.formatted) }}
            />
            <div
              className={styles.priceWithDiscount}
              dangerouslySetInnerHTML={{ __html: String(cartTotals?.total?.formatted) }}
            />
          </OpText>
        )}
        {!discountAvaiable && (
          <div
            className={styles.regularPrice}
            dangerouslySetInnerHTML={{ __html: String(cartTotals?.total?.formatted) }}
          />
        )}
      </div>
      {discountAvaiable && (
        <div
          className={styles.motivation}
          dangerouslySetInnerHTML={{
            __html: t('txt_you_saved_with_order', { saved: String(cartTotals?.totalDiscount?.formatted) }),
          }}
        />
      )}
    </div>
  );
};

export default OrderTotal;
